import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CircularProgress from "@mui/material/CircularProgress";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "layouts/approval/components/Table";
import axios from "axios";
import { useSnackbar } from "notistack";
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from "@mui/material/IconButton";

function Approval() {
  const { enqueueSnackbar } = useSnackbar();
  const [items, setItems] = useState([]);
  const [approvedItems, setApprovedItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reasonType, setReasonType] = useState("fixed");
  const [otherReason, setOtherReason] = useState("");
  const [reasonModalOpen, setReasonModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [loadingAccept, setLoadingAccept] = useState({});
  const [loadingReject, setLoadingReject] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState("")

  useEffect(() => {
    fetchItems();
    fecthapprovedItems();
  }, []);

  const fetchItems = (approvalStatuses = ['1', '2']) => {
    setLoading(true); // Set loading state to true while fetching
  
    // Ensure approvalStatuses is an array and not empty
    const queryApprovalStatuses = Array.isArray(approvalStatuses) && approvalStatuses.length
      ? approvalStatuses.join(',')
      : '';
  
    axios
      .get("https://f3lmjrtyv7.execute-api.ap-southeast-1.amazonaws.com/default/getApprovalList", {
        params: { approval_statuses: queryApprovalStatuses }
      })
      .then((response) => {
        console.log("Response data:", response.data); // Log response data
        setItems(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching items:", error);
        setError("Failed to fetch items. Please try again later."); // Set a user-friendly error message
        setLoading(false);
      });
  };

  const fecthapprovedItems = (approvalStatuses = ['3']) => {
    setLoading(true); // Set loading state to true while fetching
  
    // Ensure approvalStatuses is an array and not empty
    const queryApprovalStatuses = Array.isArray(approvalStatuses) && approvalStatuses.length
      ? approvalStatuses.join(',')
      : '';
  
    axios
      .get("https://f3lmjrtyv7.execute-api.ap-southeast-1.amazonaws.com/default/getApprovalList", {
        params: { approval_statuses: queryApprovalStatuses }
      })
      .then((response) => {
        console.log("Response data:", response.data); // Log response data
        setApprovedItems(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching items:", error);
        setError("Failed to fetch items. Please try again later."); // Set a user-friendly error message
        setLoading(false);
      });
  };
  
  

  const handleApproval = (itemId, approvalStatus, email) => {
    setLoadingAccept((prev) => ({ ...prev, [itemId]: true })); // Set loading state to true for specific item
    const requestBody = {
      itemId: itemId,
      isApproved: approvalStatus,
      email: email
    };

    axios
      .post(
        "https://cfqafm7rri.execute-api.ap-southeast-1.amazonaws.com/default/updateApprovalList",
        {
          body: JSON.stringify(requestBody),
        }
      )
      .then((response) => {
        console.log("Approval response:", response.data); // Log approval response
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.Username === itemId ? { ...item, approved: approvalStatus } : item
          )
        );
        setReasonType("fixed");
        setOtherReason("");
        fetchItems(); // Refresh the list after approval
      })
      .catch((error) => console.error("Error approving item:", error))
      .finally(() =>
        setLoadingAccept((prev) => ({ ...prev, [itemId]: false }))
      ); // Set loading state back to false for specific item
  };

  const disableUser = (itemId, approvalStatus, email) => {
    setLoadingAccept((prev) => ({ ...prev, [itemId]: true })); // Set loading state to true for specific item
    const requestBody = {
      itemId: itemId,
      isApproved: "2",
      email: email
    };

    axios
      .post(
        "https://cfqafm7rri.execute-api.ap-southeast-1.amazonaws.com/default/updateApprovalList",
        {
          body: JSON.stringify(requestBody),
        }
      )
      .then((response) => {
        console.log("Approval response:", response.data); // Log approval response
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.Username === itemId ? { ...item, approved: approvalStatus } : item
          )
        );
        setReasonType("fixed");
        setOtherReason("");
        fetchItems(); // Refresh the list after approval
      })
      .catch((error) => console.error("Error approving item:", error))
      .finally(() =>
        setLoadingAccept((prev) => ({ ...prev, [itemId]: false }))
      ); // Set loading state back to false for specific item
  };

  const handleReject = (itemId) => {
    setSelectedItemId(itemId);
    setReasonModalOpen(true);
  };

  const handleModalClose = () => {
    setReasonModalOpen(false);
    setReasonType("fixed");
    setOtherReason("");
  };

  const handleModalSubmit = () => {
    setLoadingReject(true); // Set loading state to true

    const rejectionReason = reasonType;

    const requestBody = {
      itemId: selectedItemId,
      isApproved: "2",
      reason: rejectionReason,
      email: selectedEmail
    };

    axios
      .post(
        "https://cfqafm7rri.execute-api.ap-southeast-1.amazonaws.com/default/updateApprovalList",
        {
          body: JSON.stringify(requestBody),
        }
      )
      .then((response) => {
        console.log("Rejection response:", response.data); // Log rejection response
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.Username === selectedItemId ? { ...item, approved: false } : item
          )
        );
        setReasonModalOpen(false);
        fetchItems(); // Refresh the list after rejection
      })
      .catch((error) => console.error("Error rejecting item:", error))
      .finally(() => setLoadingReject(false)); // Set loading state back to false
  };

  const handleReasonTypeChange = (event) => {
    setReasonType(event.target.value);
  };

  // const handleOtherReasonChange = (event) => {
  //   setOtherReason(event.target.value);
  // };

  const viewSSM = (company) => {
    // Assuming your S3 bucket URL follows a certain pattern

    console.log(company)
    const s3URL = `https://certificatesys.s3.ap-southeast-1.amazonaws.com/${company}/ssm`;
    
    axios.head(s3URL)
      .then((response) => {
        if (response.status === 200) {
          window.open(s3URL, "_blank");
        }
      })
      .catch((error) => {
        if (error.response && (error.response.status === 403 || error.response.status === 404)) {
          enqueueSnackbar("Organizer didn't complete the verification", { variant: 'error' });
        } else {
          enqueueSnackbar("An unexpected error occurred", { variant: 'error' });
        }
      });
  };

  const rows = items.map((item) => {
    const email = item.Attributes.find((attr) => attr.Name === "email").Value;
    const company = item.Attributes.find((attr) => attr.Name === "custom:company").Value;

    return {
      Email: email,
      Company: company,
      SSM: (
        <IconButton aria-label="view" onClick={() => viewSSM(company)}>
          <VisibilityIcon />
        </IconButton>
      ),
      Actions: (
        <SuiBox display="flex" justifyContent="center">
          <SuiButton
            color="success"
            onClick={() => handleApproval(item.Username, "3", email)}
            disabled={item.approved === "2" || loadingAccept[item.Username]}
          >
            {loadingAccept[item.Username] ? "Accepting..." : "Approve"}
          </SuiButton>
          <SuiBox mx={1}>
            <SuiButton
              color="error"
              onClick={() => {
                setSelectedItemId(item.Username);
                setSelectedEmail(email)
                setReasonModalOpen(true);
              }}
              disabled={item.approved === "1"}
            >
              Reject
            </SuiButton>
          </SuiBox>
        </SuiBox>
      ),
    };
  });

  const approvedRows = approvedItems
  .filter((item) => {
    // Find the approvalStatus attribute
    const approvalStatusAttr = item.Attributes.find((attr) => attr.Name === "custom:approvalStatus");
    // Check if approvalStatus exists and equals "3"
    return approvalStatusAttr && approvalStatusAttr.Value === "3";
  })
  .map((item) => {
    const email = item.Attributes.find((attr) => attr.Name === "email").Value;
    const company = item.Attributes.find((attr) => attr.Name === "custom:company").Value;

    return {
      Email: email,
      Company: company,
      Actions: (
          <SuiButton
            color="error"
            onClick={() => disableUser(item.Username, "2", email)}
          >
            Disable user
          </SuiButton>
      ),
    };
  });

  const rejectedRows = items
  .filter((item) => {
    // Find the approvalStatus attribute
    const rejectionReason = item.Attributes.find((attr) => attr.Name === "custom:rejectionReason");
    // Check if approvalStatus exists and equals "3"
    return rejectionReason && rejectionReason.Value != "";
  })
  .map((item) => {
    const email = item.Attributes.find((attr) => attr.Name === "email").Value;
    const company = item.Attributes.find((attr) => attr.Name === "custom:company").Value;

    return {
      Email: email,
      Company: company,
    };
  });


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                <SuiTypography variant="h6">Approvals List</SuiTypography>
              </SuiBox>
              <SuiBox px={2}>
                {loading ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <CircularProgress />
                  </SuiBox>
                ) : error ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Typography variant="body1" color="error">
                      Error fetching items.
                    </Typography>
                  </SuiBox>
                ) : (
                  <Table
                    columns={[
                      { name: "Email", align: "left" },
                      { name: "Company", align: "left" },
                      { name: "SSM", align: "center" },
                      { name: "Actions", align: "center" },
                    ]}
                    rows={rows}
                  />
                )}
              </SuiBox>
            </Card>
          </Grid>
        </Grid>
      </SuiBox>

      <SuiBox>
      <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                <SuiTypography variant="h6">Approved List</SuiTypography>
              </SuiBox>
              <SuiBox px={2}>
                {loading ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <CircularProgress />
                  </SuiBox>
                ) : error ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <SuiTypography variant="body1" color="error">
                      Error fetching items.
                    </SuiTypography>
                  </SuiBox>
                ) :  approvedRows.length === 0 ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <SuiTypography variant="body1">There are no approved users right now.</SuiTypography>
                  </SuiBox>
                ) : (
                  <Table
                    columns={[
                      { name: "Email", align: "left" },
                      { name: "Company", align: "left" },
                      // { name: "SSM", align: "center" },
                      { name: "Actions", align: "center" },
                    ]}
                    rows={approvedRows}
                  />
                )}
              </SuiBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                <SuiTypography variant="h6">Rejected List</SuiTypography>
              </SuiBox>
              <SuiBox px={2}>
                {loading ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <CircularProgress />
                  </SuiBox>
                ) : error ? (
                  <SuiBox display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Typography variant="body1" color="error">
                      Error fetching items.
                    </Typography>
                  </SuiBox>
                ) : (
                  <Table
                    columns={[
                      { name: "Email", align: "left" },
                      { name: "Company", align: "left" },
                      // { name: "SSM", align: "center" },
                      // { name: "Actions", align: "center" },
                    ]}
                    rows={rejectedRows}
                  />
                )}
              </SuiBox>
            </Card>
          </Grid>
        </Grid>
      </SuiBox>


      <Modal
        open={reasonModalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <SuiBox
          borderRadius="xl"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            
          }}
        >
          <SuiTypography id="modal-modal-title" variant="h6" component="h2">
            Reason for Rejection
          </SuiTypography>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="fixed"
            name="radio-buttons-group"
            value={reasonType}
            onChange={handleReasonTypeChange}
          >
            <FormControlLabel value="SSM not Valid" control={<Radio />} label="SSM not Valid" />
            <FormControlLabel value="SSM not Clear" control={<Radio />} label="SSM not Clear" />
            <FormControlLabel value="Company already register" control={<Radio />} label="Company already register" />
            {/* <FormControlLabel value="other" control={<Radio />} label="Other Reason" /> */}
          </RadioGroup>
          {/* {reasonType === "other" && (
            <TextField
              fullWidth
              variant="outlined"
              label="Other Reason"
              value={otherReason}
              onChange={handleOtherReasonChange}
              multiline
              rows={4}
              sx={{ mt: 2 }}
            />
          )} */}
          <Box mt={2} display="flex" justifyContent="flex-end">
            <SuiButton
              variant="contained"
              color="dark"
              onClick={handleModalSubmit}
              disabled={loadingReject}
            >
              {loadingReject ? <CircularProgress size={24} color="inherit" /> : "Submit"}
            </SuiButton>
            <SuiButton
              variant="outlined"
              color="error"
              onClick={handleModalClose}
              sx={{ ml: 2 }}
            >
              Cancel
            </SuiButton>
          </Box>
        </SuiBox>
      </Modal>
    </DashboardLayout>
  );
}

export default Approval;
